import React from 'react';
import { Link } from 'react-router-dom';
import { content } from '../data';
import { Facebook } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-blue-950 text-white pt-24 pb-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16">
          <div className="col-span-1 lg:col-span-1">
            <Link to="/">
              <img 
                src={content.images.logo} 
                alt="Lenes Køreskole" 
                className="h-16 w-auto brightness-0 invert mb-8"
              />
            </Link>
            <p className="text-white leading-relaxed mb-8">
              Din vej til sikkert kørekort i Aabenraa. Professionel undervisning i trygge rammer med fokus på dig.
            </p>
            <div className="flex space-x-4">
              <a 
                href={content.contact.facebook} 
                target="_blank" 
                rel="noopener noreferrer" 
                className="bg-blue-900 p-3 hover:bg-blue-600 rounded-full transition-colors"
              >
                <Facebook size={20} />
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-lg font-semibold uppercase tracking-widest mb-8 border-b border-white/10 pb-4">Genveje</h4>
            <ul className="space-y-4">
              {content.navigation.map((item) => (
                <li key={item.name}>
                  <Link 
                    to={item.href.startsWith('#') ? `/${item.href}` : item.href} 
                    className="text-white hover:text-white/80 transition-colors"
                  >
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div id="kontakt">
            <h4 className="text-lg font-semibold uppercase tracking-widest mb-8 border-b border-white/10 pb-4">Kontakt</h4>
            <ul className="space-y-4 text-white">
              <li>{content.contact.address}</li>
              <li>{content.contact.phone}</li>
              <li>{content.contact.email}</li>
              <li>CVR: {content.contact.cvr}</li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-semibold uppercase tracking-widest mb-8 border-b border-white/10 pb-4">Åbningstider</h4>
            <ul className="space-y-4 text-white">
              <li className="flex justify-between">
                <span>Mandag - Torsdag</span>
                <span>08:00 - 17:00</span>
              </li>
              <li className="flex justify-between">
                <span>Fredag</span>
                <span>08:00 - 15:00</span>
              </li>
              <li className="flex justify-between font-semibold text-white">
                <span>Lørdag - Søndag</span>
                <span>Lukket</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-12 border-t border-white/10 text-center text-white text-sm">
          <p>&copy; {new Date().getFullYear()} Lenes Køreskole. Alle rettigheder forbeholdes.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
